export default {
    name: '课程/发卡',
    permissionsKey:"YY-KC/FK",
    icon: 'fa fa-envelope-open',
    children: {
        courseCardList:{
            name: '课程/发卡',
            permissionsKey:"YY-KC/FK-LI",
            path: '/course_issuance/course_card_list',
        },
        organCardList:{
            name: '机构/发卡',
            permissionsKey:"YY-FC/FK-JGFKJL",
            path: '/course_issuance/organ_card_list',
        },
        // clearCarList:{
        //   name: '清除学习卡权限',
        //   permissionsKey:"",
        //   path: '/course_issuance/clear_car_list',
        // }
    }
};
